<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 260px">Relatório de pacientes</legend>
      <div class="row">
        <div class="title-group">Situação</div>
        <div class="group-itens">
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="ativo" v-model="form.ativo" @click="desativaTodos" />
            <label class="form-check-label"> Ativos </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="inativo" v-model="form.inativo" @click="desativaTodos" />
            <label class="form-check-label"> Inativos </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Tipo</div>
        <div class="group-itens">
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="MILITAR" v-model="form.militar" @click="desativaTodos" />
            <label class="form-check-label"> Militar </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="DEPENDENTE" v-model="form.dependenteMilitar" @click="desativaTodos" />
            <label class="form-check-label"> Dependente </label>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchPaciente">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataPaciente.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataPaciente.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <a-table :dataSource="dataPaciente" :columns="columns">
            <template #dependenteMilitar="{ record }">
              <span v-if="record.dependenteMilitar">{{ record.dependenteMilitar.nome }}</span>
            </template>
          </a-table>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<!-- <template>
    <div class="row">
 
        <div class="row">
            <div class="col">
                <div class="form-check">
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-check">
                   
                </div>
            </div>
        </div> 
    </div>
</template> -->

<script>
import { abrirImpressaoPorBlob, encaminharEmailTo } from '@/utils/servicos-utils';
import { getPacienteRelatorio } from '@/components/service/pacienteService';
import { gerarRelatorioHtmlPaciente, gerarRelatorioPacientes } from '@/components/service/gerarRelatorio';

export default {
  name: 'PacientesRelatorio',
  data() {
    return {
      form: {
        todos: false,
        ativo: false,
        inativo: false,
        militar: false,
        dependenteMilitar: false,
        pdf: undefined,
      },
      dataPaciente: [],
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Tipo',
          dataIndex: 'tipoPaciente',
          key: 'tipoPaciente',
        },
        {
          title: 'E-mail',
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: 'Telefone',
          dataIndex: 'telefoneCelular',
          key: 'telefoneCelular',
        },
        {
          title: 'Dependente',
          dataIndex: 'dependenteMilitar',
          key: 'dependenteMilitar',
          slots: { customRender: 'dependenteMilitar' },
        },
      ],
    };
  },
  methods: {
    async searchPaciente() {
      await getPacienteRelatorio(this.form).then((r) => {
        this.dataPaciente = r.data;
      });
    },
    todos() {
      this.form.ativo = false;
      this.form.inativo = false;
      this.form.militar = false;
      this.form.dependenteMilitar = false;
    },
    desativaTodos() {
      this.form.todos = false;
    },
    async imprimirPDF() {
      if (this.dataPaciente.length > 0) {
        await gerarRelatorioPacientes({
          listaDadosDocumento: this.dataPaciente,
          nomeDocumentoHtml: 'relatorio-pacientes.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dataPaciente.length > 0) {
        await gerarRelatorioHtmlPaciente({
          listaDadosDocumento: this.dataPaciente,
          nomeDocumentoHtml: 'relatorio-pacientes.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Pacientes', r.data);
        });
      }
    },
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
